// Renders one PDF page as the board background. Pages are pre-rendered to
// JPEG images by the backend (WhiteboardPdf service) — pixel-perfect Arabic
// text with zero client-side PDF machinery; only page numbers cross the relay.
// KEEP IN SYNC with the original in dashboard/src/pages/LiveWhiteboard/components/PdfBackdrop.jsx.
import { useEffect, useState } from "react";

const PdfBackdrop = ({ url, page, onAspect }) => {
    const [loadedSrc, setLoadedSrc] = useState(null);
    const src = `${String(url).replace(/\/$/, "")}/page-${page}.jpg`;

    // preload so page flips never flash white
    useEffect(() => {
        let cancelled = false;
        const image = new Image();
        image.onload = () => {
            if (cancelled) return;
            if (onAspect && image.naturalHeight > 0) {
                onAspect(image.naturalWidth / image.naturalHeight);
            }
            setLoadedSrc(src);
        };
        image.src = src;
        return () => {
            cancelled = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [src]);

    return (
        <div
            style={{
                position: "absolute",
                inset: 0,
                backgroundColor: "#fff",
            }}
        >
            {loadedSrc && (
                <img
                    src={loadedSrc}
                    alt=""
                    draggable={false}
                    style={{
                        position: "absolute",
                        inset: 0,
                        width: "100%",
                        height: "100%",
                        display: "block",
                        userSelect: "none",
                    }}
                />
            )}
        </div>
    );
};

export default PdfBackdrop;
